<div class="mu-layout-auth">
  <div class="mu-layout-auth-top-bar">
    <img src="assets/images/logos/logo-h-mu.svg" alt="" />
  </div>
  <div class="mu-layout-auth-container p-grid">
    <div class="mu-layout-auth-content p-col-12 p-lg-4">
      <p-tabView class="mu-layout-auth-tab-view" (onChange)="changeTab($event.index)" [activeIndex]="tab">
        <p-tabPanel [header]="'page.login.tabs.login' | translate">
          <router-outlet *ngIf="tab === indexTabs.login"></router-outlet>
        </p-tabPanel>
        <p-tabPanel [header]="'page.login.tabs.register' | translate">
          <router-outlet *ngIf="tab === indexTabs.signup"></router-outlet>
        </p-tabPanel>
        <p-tabPanel [disabled]="true">
          <router-outlet *ngIf="tab === indexTabs.recover"></router-outlet>
        </p-tabPanel>
      </p-tabView>
    </div>
    <div class="mu-layout-auth-banner p-col-12 p-lg-8">
      <a href="https://api.whatsapp.com/send?phone=%20573006393715&text=Hola%2C%20necesito%20una%20asesoria">
        <img src="assets/images/backgrounds/bg_login_auth.png" alt="imagen connect to whatsapp" />
      </a>
    </div>
  </div>
</div>
<app-mu-toast [key]="'toast-layout'" [position]="'top-right'"></app-mu-toast>
<app-mu-alert-modal-dialog
  title="{{ 'context.personBilling.register.successModal.title' | translate }}"
  icon="fa-check-circle"
  [showFlag]="settings?.showFlag"
  [flagList]="settings?.flagList"
  [actionFlag]="settings?.actionFlag"
  [loaderFlag]="settings?.loaderFlag"
  buttonMainActionLabel="form.button.accept"
  message="{{ 'context.personBilling.register.successModal.text' | translate }}"
>
</app-mu-alert-modal-dialog>
